import { Button, ColourStateSolid } from '@ukpostbox/frontend-framework';
import React from 'react';
import { SignUpPlanType } from '../Types/SignUp/SignUpPlan';
import { SignUpGenericSectionInterface } from '../Types/SignUp/SignUpSection';

export type SelectPlanType = {
	itemProps: SignUpPlanType;
	parentProps: SignUpGenericSectionInterface;
};

function SelectPlan(props: SelectPlanType) {
	const planSelected = props.parentProps.value === props.itemProps.id;

	const HandleCallBack = () => {
		if (props.parentProps.value === props.itemProps.id) {
			if (props.parentProps.onCancelCallback) {
				props.parentProps.onCancelCallback();
			}
		} else if (props.parentProps.onChangeCallback) {
			props.parentProps.onChangeCallback(props.itemProps);
		}
	};

	return (
		<Button
			title={planSelected ? 'Selected' : 'Select'}
			colour={planSelected ? ColourStateSolid.Selected : ColourStateSolid.Primary}
			fullWidth
			onClick={() => HandleCallBack()}
		/>
	);
}

export { SelectPlan };
